/* eslint-disable */
// @ts-nocheck
import { AlertInvocationData } from '../../../../shared/types/alertNotifications.types';
import getUnsubsctibeAlertNotificationUrl from '../../common/support/utils/getUnsubsctibeAlertNotificationUrl';
import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import NotificationActions from './NotificationActions';

const UnsubscribeAlertNotification = new ReduxAsyncAction('ALERT_NOTIFICATION_UNSUBSCRIBE');
UnsubscribeAlertNotification.registerRequest(function (alertId: string, emailAddress: string, token: string) {
  const unsubsctibeAlertNotificationUrl = getUnsubsctibeAlertNotificationUrl(alertId, emailAddress, token);

  return dash_api
    .delete(unsubsctibeAlertNotificationUrl)
    .then((data) => {
      NotificationActions.showNotification(
        'You are not subscribed to this alert anymore and will no longer receive emails.',
        'success'
      );
      return data.status;
    })
    .catch(() => {
      NotificationActions.showNotification('Cannot unsubscribe. Please try again.', 'error');
    });
});
export const unsubscribeAlertNotification = UnsubscribeAlertNotification.request;
export const ALERT_NOTIFICATION_UNSUBSCRIBE: any = UnsubscribeAlertNotification.constants;

const InvokeAlertNotification = new ReduxAsyncAction('ALERT_NOTIFICATION_INVOKE');
InvokeAlertNotification.registerRequest(function (alertName: string, alertData: AlertInvocationData) {
  const unsubscribeAlertNotificationUrl = `/v1/notifications/alert/${alertName}/invoke`;

  return dash_api.post(unsubscribeAlertNotificationUrl, alertData);
});
export const invokeAlertNotification = InvokeAlertNotification.request;
export const ALERT_NOTIFICATION_INVOKE: any = InvokeAlertNotification.constants;

const GetAlerts = new ReduxAsyncAction('ALERT_NOTIFICATION_GET_ALERTS');
GetAlerts.registerRequest(function () {
  const getAlertsUrl = `/v1/notifications/alerts`;

  return dash_api.get(getAlertsUrl);
});
export const getAlerts = GetAlerts.request;
export const ALERT_NOTIFICATION_GET_ALERTS: any = GetAlerts.constants;
